import { useState } from "react";
import SubHeader from "../../../components/SubHeader";
import Footer from "../../../components/Footer";
import { setCreatorMode } from "../../../store/editorSlice";
import { CreatorMode } from "../../../types/editorModeEnum";
import { useDispatch, useSelector } from "react-redux";
import ScenarioUtils from "../../../utils/scenarioUtils";
import { RootState } from "../../../store/store";
import RoleRowSetup from "./RoleRowSetup";
import { RoleClassEnum } from "../../../types/roleClassEnum";
import { TOWN_ROLES } from "../../../types/roleEnum";
import RoleString from "../../../components/RoleString";

function RoleSetup(props: { raw_scenario: string[], onSave: (edited_scenario: string[]) => void }) {
    const dispatch = useDispatch();
    const { raw_scenario, onSave } = props;
    const [raw, setRaw] = useState(raw_scenario);   
    const [rowIndex, setRowIndex] = useState(0);   
    const { creatorMode } = useSelector((state: RootState) => state.editor); 


    const onRoleRowSave = (editedRow: string) => {
        const clone = [...raw];
        clone[rowIndex] = editedRow;
        setRaw(clone);
    }

    if(creatorMode === CreatorMode.SetupRoleRow || creatorMode === CreatorMode.SetupSingleRoleRow){
        return <RoleRowSetup onSave={onRoleRowSave} rowString={raw[rowIndex]}/>
    }    

    const getRow = (rowString: string, index: number) => {
        const oddEven = index % 2 == 1 ? 'odd' : 'even reverted';
        let labelClass = 'town';
        let letter='T';
        switch(ScenarioUtils.CheckRole(rowString)) {
            case RoleClassEnum.Town:
                labelClass = 'town';
                letter='T';
                break;
            case RoleClassEnum.Mafia:
                labelClass = 'mafia';
                letter='M';
                break;
            case RoleClassEnum.Neutral:
                labelClass = 'neutral';
                letter='N';
                break;
            default:
                labelClass = 'mixed';
                letter='?';
                break;
        }
        return <div className={`mafia-role-row ${oddEven}`}>
            <div className={`label label-${labelClass}`}>{letter}</div>
            <div className="pos">{index + 1}:</div>
            <div className="name">{rowString}</div>
            <div className="button">
                <button onClick={onEditClick} value={index}>Edit</button>
                <button onClick={onRemoveClick} value={index}>Remove</button>
            </div>
        </div>
    }

    const onRemoveClick = (e: any) => {
        const index = +e.target.value;
        const clone = [...raw];
        clone.splice(index,1);
        setRaw(clone);
    }

    const onEditClick = (e: any) => {
        const index = +e.target.value;
        setRowIndex(index);
        dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
    }

    const onSaveClick = () => {
        onSave(raw);
        dispatch(setCreatorMode(CreatorMode.Main));
    }

    const onAddRoleClick = () => {
        setRaw([
            ...raw,
            TOWN_ROLES[0],
        ])
        setRowIndex(raw.length);
        dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
    }
    return <div className="mafia-container-wrapper">
        <div className="mafia-content">
            <SubHeader>Setup Roles</SubHeader>
            <div className="mafia-role-list mafia-list-container">
                <div className={`mafia-role-row centered`}><RoleString raw_scenario={raw} /></div>
                {
                    raw.map((row, index) => getRow(row, index))
                }
            </div>
        </div>
        <Footer>
            <button onClick={() => dispatch(setCreatorMode(CreatorMode.Main))}>Cancel</button>
            <button onClick={() => onAddRoleClick()}>Add Role</button>
            <button onClick={onSaveClick}>Save</button>
        </Footer>
    </div>
}

export default RoleSetup;